import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-info-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent($setup.currentComponent), {
      bookingDatesCount: $setup.bookingDatesCount,
      totalAmount: $props.totalAmount,
      oneTimeFare: $props.oneTimeFare,
      currentBookInterval: $props.currentBookInterval
    }, null, 8 /* PROPS */, ["bookingDatesCount", "totalAmount", "oneTimeFare", "currentBookInterval"]))
  ]))
}